/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';
import { AssetsService } from './services/AssetsService';
import { AssetTypesService } from './services/AssetTypesService';
import { AuditLogsService } from './services/AuditLogsService';
import { AuthService } from './services/AuthService';
import { DashboardService } from './services/DashboardService';
import { HealthService } from './services/HealthService';
import { LocationsService } from './services/LocationsService';
import { MaintenancesService } from './services/MaintenancesService';
import { MovementsService } from './services/MovementsService';
import { UsersService } from './services/UsersService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class ApiClient {
  public readonly assets: AssetsService;
  public readonly assetTypes: AssetTypesService;
  public readonly auditLogs: AuditLogsService;
  public readonly auth: AuthService;
  public readonly dashboard: DashboardService;
  public readonly health: HealthService;
  public readonly locations: LocationsService;
  public readonly maintenances: MaintenancesService;
  public readonly movements: MovementsService;
  public readonly users: UsersService;
  public readonly request: BaseHttpRequest;
  constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
    this.request = new HttpRequest({
      BASE: config?.BASE ?? '',
      VERSION: config?.VERSION ?? '1.0',
      WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
      CREDENTIALS: config?.CREDENTIALS ?? 'include',
      TOKEN: config?.TOKEN,
      USERNAME: config?.USERNAME,
      PASSWORD: config?.PASSWORD,
      HEADERS: config?.HEADERS,
      ENCODE_PATH: config?.ENCODE_PATH,
    });
    this.assets = new AssetsService(this.request);
    this.assetTypes = new AssetTypesService(this.request);
    this.auditLogs = new AuditLogsService(this.request);
    this.auth = new AuthService(this.request);
    this.dashboard = new DashboardService(this.request);
    this.health = new HealthService(this.request);
    this.locations = new LocationsService(this.request);
    this.maintenances = new MaintenancesService(this.request);
    this.movements = new MovementsService(this.request);
    this.users = new UsersService(this.request);
  }
}

